<template>
<tr>
  <!-- icon 1 -->
  <td class="threadslist__td_center td_icon"> <img :src="publicPath + getThreadIcon(thread)" /></td>
  <!-- icon 2 -->
  <td class="threadslist__td_center td_icon">
    <img :src="publicPath + 'threadicons/icon' + thread.icon_id + '.gif'" v-if="thread.icon_id !== 0 && thread.icon_id !== null" />
  </td>
  <!-- thread name and description -->
  <td>
    <div>
      <span>
        <template v-if="thread.moved_to.length > 0">Перемещено: </template>
        <template v-else-if="thread.pinned">Важно: </template>
        <template v-else-if="thread.state === 'closed'"><b>Закрыто:</b> </template>
        <template v-else-if="thread.poll_state === '1'">Опрос: </template>
        <template v-if="thread.topic_hasattach"><a :title="thread.topic_hasattach+' присоединения: Просмотр'" @click="viewAttachments(thread.tid)"><img src="../assets/attachicon.gif" /></a></template>
        <a :href="'index.php?showtopic='+getThreadId(thread.tid, thread.moved_to)" v-bind:class="{threadlist__title_strike: thread.state === 'closed' && !thread.pinned}"
          :title="'Тема создана: ' + $options.filters.formatDate(thread.start_date)">{{htmlDecode(thread.title)}}</a></span>
      <!-- перейти на страницу треда, иконка -->
      <template v-if="thread.posts >= 20"><span v-html="nbsp"></span><span v-html="nbsp"></span>
        <a title="Перейти на страницу:..."><img class="threadslist__goto_page_icon" src="../assets/pages_icon.gif" /></a>
        <span v-html="nbsp"></span></template>
      <!-- страница [1] -->
      <span class="threadlist__pageblock thread_pages" v-if="thread.posts >= 20"><a :href="'index.php?showtopic='+thread.tid+'&st=0'">1</a></span>
      <span class="threadlist__pageblock thread_pages" v-if="thread.posts >= 20"><a :href="'index.php?showtopic='+thread.tid+'&st=20'">2</a></span>
      <span class="threadlist__pageblock thread_pages" v-if="thread.posts >= 40"><a :href="'index.php?showtopic='+thread.tid+'&st=40'">3</a></span>
      <span class="threadlist__pageblock thread_pages" v-if="thread.posts >= 60 && thread.posts < 100"><a :href="'index.php?showtopic='+thread.tid+'&st=60'">4</a></span>
      <!-- страница >>[последняя] -->
      <span class="threadlist__pageblock thread_pages firstLast" v-if="thread.posts >= 80"><a :href="'index.php?showtopic='+thread.tid+'&st='+(Math.ceil(thread.posts/20)-1)*20">» {{Math.ceil(thread.posts/20)}}</a></span>
      <br>
      <span class="threadlist__thread_descr">{{htmlDecode(thread.description)}}</span>
    </div>
  </td>
  <!-- replies -->
  <td class="threadslist__td_center">
    <template v-if="thread.posts === -1 || thread.moved_to.length > 0">--</template>
    <template v-else><a @click="whoPosted(thread.tid)">{{thread.posts | formatInt}}</a></template> </td>
  <!-- author -->
  <td class="threadslist__td_center">
    <template v-if="thread.starter_id > 0">
      <a :href="'index.php?showuser='+thread.starter_id">{{htmlDecode(thread.starter_name)}}</a>
    </template>
    <template v-else>
      {{htmlDecode(thread.starter_name)}}
    </template>
  </td>
  <!-- views -->
  <td class="threadslist__td_center">
    <template v-if="thread.posts === -1 || thread.moved_to.length > 0">--</template>
    <template v-else>{{thread.views | formatInt}}</template></td>
  <!-- update -->
  <td>
    <div class="threadslist__update">
      <span>{{thread.last_post | formatDate}}</span><br>
      <span>
        <a :href="'index.php?showtopic='+thread.tid+'&view=getlastpost'">Посл. сообщение:</a>&nbsp;
        <template v-if="thread.starter_id > 0">
          <a :href="'index.php?showuser='+thread.last_poster_id"><b>{{htmlDecode(thread.last_poster_name)}}</b></a>
        </template>
        <template v-else>
          <span style="color:#fff;">{{htmlDecode(thread.last_poster_name)}}</span>
        </template>
      </span>
    </div>
  </td>
</tr>
</template>

<script>
export default {
  props: ['thread'],
  data: function() {
    return {
      publicPath: process.env.BASE_URL
    }
  },
  methods: {
    getThreadIcon(thread) {
      //console.log(`thread: [${thread.tid}] ${thread.title}`);
      if (thread.moved_to.length > 0) {
        return ('f_moved.gif');
      } else if (thread.state === "closed") {
        return ('f_closed.gif');
      } else if (thread.poll_state === "1") {
        return ('f_poll_no.gif');
      } else if (thread.posts >= 15) {
        return ('f_hot_no.gif');
      } else {
        return ('f_norm_no.gif');
      }
    },
    whoPosted(threadId) {
      console.log("Who posted in this here thread?! : " + threadId);
    },
    viewAttachments(threadId) {
      console.log("Display attachments for thread: " + threadId);
    },
    getThreadId(threadId, moved_to) {
      if (moved_to.length > 0 && moved_to.includes('&')) {
        //moved_to will be like "12651&17", where first digit is the id of the new thread, and second digit is the forum id
        //we only need the first digit
        return moved_to.split('&')[0];
      }
      return threadId;
    }
  }
}
</script>
